<template>
  <div
    class="login-page-flame d-flex flex-row align-center my-nielseniq-bg"
  >
    <!-- <v-spacer /> -->
    <div
      class="login-page-content px-16 pb-16 d-flex flex-row align-center"
    >
      <v-spacer />
      <div>
        <div class="d-flex flex-row align-center">
          <v-icon
            class="success--text"
            size="42"
          >
            mdi-ruler-square-compass
          </v-icon>
          <!-- <span class="black--text text-h5 ml-4">OAT Tool</span> -->
          <span class="black--text text-h5 ml-4">Log In</span>
        </div>
        <div class="d-flex flex-row align-center mt-12">
          <v-spacer />
          <!-- comment for updating -->
          <!-- <div
            v-if="new Date().getFullYear() === 2022"
          >
            The system is maintaining, please try after Jan. 4th
          </div> -->
          <!-- # ms change @click -->
          <v-btn
            x-large
            rounded
            dark
            :color="loading ? 'black' : 'my-action success'"
            :text="loading"
            :loading="loading"
            @click="loginMsal"
          >
            Login
            <v-icon class="ml-3">
              mdi-login
            </v-icon>
          </v-btn>
          <!-- <v-spacer /> -->
        </div>
      </div>
      <v-spacer />
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    data: () => ({
      // # ms - change
      loading: false
    }),

    computed: {
      // # ms - change
      ...mapState(['msal'])
    },
    // # ms - delete check access of beforeMount / created / beforeDestroy

    methods: {
      // # ms - delete stopLoading / loginGg
      // # ms - add
      async loginMsal () {
        this.loading = true
        try {
          localStorage.clear()
          await this.msal.app.loginPopup({ scopes: this.msal.config.scopes })
          this.$eventBus.$emit('check-access', null, () => { this.loading = false })
        } catch (err) {
          console.log('-----------------')
          console.log('Error [login ms]')
          // console.log(err)
          console.log('-----------------')
        }
      }
    }
  }
</script>

<style lang="sass">
  $login-page-flame-height: 100vh

  .login-page-flame
    height: $login-page-flame-height
    min-height: $login-page-flame-height
    background-color: rgba(0, 0, 0, .2)
    background-image: -webkit-linear-gradient(135deg, transparent 45%,rgba(255, 255, 255, 0.22) 45%,rgba(255, 255, 255, 0.22) 75%,transparent 75%,transparent)
    // background-image: -webkit-linear-gradient(315deg,rgba(4, 243, 4, 0.7) 25%,transparent 25%,transparent 50%,rgba(4, 243, 4, 0.7) 50%,rgba(4, 243, 4, 0.7) 75%,transparent 75%,transparent)
    // background-image: -webkit-linear-gradient(135deg,rgba(255, 255, 255, 0.2) 25%,transparent 25%,transparent 50%,rgba(255, 255, 255, 0.2) 50%,rgba(255, 255, 255, 0.2) 75%,transparent 75%,transparent)

  .login-page-content
    width: 100%
    min-width: 560px
    height: 100%
    background-color: rgba(255, 255, 255, .65)
</style>
